(() => {
  const normalize = (value) => {
    const match = value.trim().match(/^([A-Za-z0-9]{4})\.([A-Za-z0-9]{2})$/);
    return match && /\d/.test(value) ? match[1] + match[2] : value;
  };
  const compact = (value) => value.toUpperCase().replace(/[ .\/_-]/g, '');
  const isReference = (value) => {
    if (!/\d/.test(value) || !/^[A-Za-z0-9][A-Za-z0-9 .\/_-]*$/.test(value)) return false;
    const parts = value.split(/\s+/);
    if (parts.length > 2 || (parts.length === 2 && (parts[0].length > 4 || !/\d/.test(parts[1])))) return false;
    return /^[A-Z0-9]{4,35}$/.test(compact(value));
  };
  const unwrap = (value) => {
    const match = value.match(/^(.*?) OR body:([A-Z0-9]+) OR tag:\2$/);
    return match && isReference(match[1]) && compact(match[1]) === match[2] ? match[1] : value;
  };
  const catalogQuery = (value) => {
    if (unwrap(value) !== value) return value;
    const query = normalize(value.trim());
    return isReference(query) ? `${query} OR body:${compact(query)} OR tag:${compact(query)}` : query;
  };
  window.pwNormalizeOeQuery = normalize;
  window.pwBuildCatalogSearchQuery = catalogQuery;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (input) input.value = catalogQuery(input.value);
  }, true);
  const prepareSearchPage = () => {
    const url = new URL(window.location.href);
    if (!url.pathname.endsWith('/search')) return;
    const query = url.searchParams.get('q');
    if (!query) return;
    const expanded = catalogQuery(query);
    if (expanded !== query) {
      url.searchParams.set('q', expanded);
      window.location.replace(url.toString());
      return;
    }
    const original = unwrap(query);
    if (original === query) return;
    document.querySelectorAll('input[name="q"][type="search"]').forEach((input) => {
      if (input.value === query) input.value = original;
    });
    const root = document.getElementById('MainContent');
    if (root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!/^(SCRIPT|STYLE)$/.test(node.parentElement?.tagName || '') && node.nodeValue.includes(query)) {
          node.nodeValue = node.nodeValue.split(query).join(original);
        }
      }
    }
    document.title = document.title.split(query).join(original);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareSearchPage, { once: true });
  else prepareSearchPage();
})();